// src/components/formularios/ConfirmExitEvaluacionDialog.tsx
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import React from 'react';

import gorilaWaitImg from '../../imagenes/Gorilas/gorila_wait.png';

interface Props {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
  loading?: boolean;
}

export default function ConfirmExitEvaluacionDialog({
  open,
  onClose,
  onContinue,
  loading = false,
}: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(139, 69, 19, 0.5)',
            backdropFilter: 'blur(4px)',
          },
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: '12px',
          overflow: 'visible',
          position: 'relative',
        },
      }}
    >
      <Box
        component="img"
        src={gorilaWaitImg}
        alt="Gorila Wait"
        sx={{
          position: 'absolute',
          right: 0,
          top: { xs: '-35px', sm: '-45px', md: '-50px' },
          transform: 'translateX(0)',
          width: { xs: '80px', sm: '100px', md: '120px' },
          height: 'auto',
          zIndex: 1,
          pointerEvents: 'none',
        }}
      />
      <DialogTitle
        sx={{
          backgroundColor: '#000',
          color: '#fff',
          fontWeight: 'bold',
          borderTopLeftRadius: '12px',
          borderTopRightRadius: '12px',
          pr: { xs: 2, sm: 10 },
        }}
      >
        ¡Ey! No tan rápido...
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: '#fff', pt: 2, pb: 1 }}>
        <Typography variant="body1" color="text.primary" sx={{ mb: 0 }}>
          Si cierras ahora, la evaluación se enviará tal y como esté rellenada.
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          backgroundColor: '#fff',
          px: 3,
          py: 2,
          flexDirection: 'column',
          gap: 1,
          borderBottomLeftRadius: '12px',
          borderBottomRightRadius: '12px',
        }}
      >
        <Button
          onClick={onContinue}
          disabled={loading}
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: '#21a598',
            color: '#fff',
            '&:hover': { backgroundColor: '#1a8578' },
            textTransform: 'uppercase',
            fontWeight: 'bold',
          }}
        >
          {loading ? 'Enviando...' : 'Continuar y enviar'}
        </Button>
        <Button
          onClick={onClose}
          disabled={loading}
          sx={{
            color: '#d32f2f',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: 'rgba(211, 47, 47, 0.08)',
            },
          }}
        >
          Seguir editando
        </Button>
      </DialogActions>
    </Dialog>
  );
}
